const getData = (id) => {
  return (
    window.drupalSettings?.selbsttest[id] ||
    {
      10: {
        questions: [
          {
            title: "How you doing?",
            options: [
              { question_option: "option1", score: 5 },
              { question_option: "option2", score: 2 },
            ],
          },
          {
            title: "question2",
            options: [
              { question_option: "option1", score: 10 },
              { question_option: "option2", score: 5 },
              { question_option: "option3", score: 2 },
            ],
          },
          {
            title: "question3",
            options: [
              { question_option: "option1", score: 4 },
              { question_option: "option2", score: 5 },
              { question_option: "option3", score: 2 },
            ],
          },
          {
            title: "question4",
            options: [
              { question_option: "option1", score: 4 },
              { question_option: "option2", score: 5 },
            ],
          },
          {
            title: "question5",
            options: [
              { question_option: "option1", score: 10 },
              { question_option: "option2", score: 5 },
              { question_option: "option3", score: 2 },
              { question_option: "option4", score: 6 },
            ],
          },
        ],
        result: [
          {
            text:
              "<h2>well done</h2><p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Aliquid, itaque. Rerum, in quisquam nulla sint excepturi voluptates nemo officiis accusantium ullam sapiente, quis, dolores vel aut nihil velit atque eius.</p>     ",
            range_from: 0,
            range_to: 10,
          },
          {
            text:
              "<h2>amazing</h2><p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Aliquid, itaque. Rerum, in quisquam nulla sint excepturi voluptates nemo officiis accusantium ullam sapiente, quis, dolores vel aut nihil velit atque eius.</p>     ",
            range_from: 11,
            range_to: 15,
          },
          {
            text:
              "<h2>professional</h2><p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Aliquid, itaque. Rerum, in quisquam nulla sint excepturi voluptates nemo officiis accusantium ullam sapiente, quis, dolores vel aut nihil velit atque eius.</p>      ",
            range_from: 16,
            range_to: 35,
          },
        ],
      },
      24: {
        questions: [
          {
            title: "How are you?",
            options: [
              { question_option: "fine", score: 5 },
              { question_option: "thanks", score: 2 },
            ],
          },
          {
            title: "question2",
            options: [
              { question_option: "option1", score: 10 },
              { question_option: "option2", score: 5 },
              { question_option: "option3", score: 2 },
            ],
          },
          {
            title: "question3",
            options: [
              { question_option: "option1", score: 4 },
              { question_option: "option2", score: 5 },
              { question_option: "option3", score: 2 },
            ],
          },
          {
            title: "question4",
            options: [
              { question_option: "option1", score: 4 },
              { question_option: "option2", score: 5 },
            ],
          },
          {
            title: "question5",
            options: [
              { question_option: "option1", score: 10 },
              { question_option: "option2", score: 5 },
              { question_option: "option3", score: 2 },
              { question_option: "option4", score: 6 },
            ],
          },
        ],
        result: [
          {
            text:
              "<h2>well done</h2><p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Aliquid, itaque. Rerum, in quisquam nulla sint excepturi voluptates nemo officiis accusantium ullam sapiente, quis, dolores vel aut nihil velit atque eius.</p>     ",
            range_from: 0,
            range_to: 10,
          },
          {
            text:
              "<h2>amazing</h2><p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Aliquid, itaque. Rerum, in quisquam nulla sint excepturi voluptates nemo officiis accusantium ullam sapiente, quis, dolores vel aut nihil velit atque eius.</p>     ",
            range_from: 11,
            range_to: 15,
          },
          {
            text:
              "<h2>professional</h2><p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Aliquid, itaque. Rerum, in quisquam nulla sint excepturi voluptates nemo officiis accusantium ullam sapiente, quis, dolores vel aut nihil velit atque eius.</p>      ",
            range_from: 16,
            range_to: 35,
          },
        ],
      },
    }[id || 10]
  );
};

export { getData };
